module.exports = __webpack_public_path__ + "img/partner06.d059ddc1.png";